import { render } from "./AddWithdrawalMethod.vue?vue&type=template&id=fd6c1e08"
import script from "./AddWithdrawalMethod.vue?vue&type=script&lang=js"
export * from "./AddWithdrawalMethod.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__